module.exports = __webpack_public_path__ + "static/Hal-header-6ee64b4309ba99c276172f6956ac6643.png";